// components
import { Paper as PaperOrigin } from 'components/UI'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'

const Header = styled.div`
  color: ${colors.blue500};
  font-size: 16px;
  font-weight: bold;
  display: flex;

  justify-content: space-between;
  align-items: center;

  flex: 1;
  border-bottom: 1px solid ${colors.blue500};
  position: relative;
  height: 32px;
`

const Paper = styled(PaperOrigin)<{ width: string }>`
  padding: 16px;
  width: ${({ width }) => width};
`

export { Header, Paper }
